/**
 * Texts for Factsheets page
 *
 * PDF DOWNLOAD INSTRUCTIONS:
 * Each factsheet has an image and a PDF download URL.
 * On image click, the PDF will be downloaded.
 * Simply edit the 'pdfUrl' field in each factsheet object below.
 */
export const factsheetsPageText = {
  title: "Factsheets - CamAPS FX",
  titleMeta: "CamAPS FX Factsheets - Quick reference guides",
  descriptionMeta:
    "Download helpful factsheets and guides for quick reference about CamAPS FX.",
  keywords:
    "camaps fx factsheets, camaps guides, diabetes app guides, insulin pump factsheets, cgm guides, pdf downloads",
  localeMeta: "de_de",

  mainHeader: "Factsheets",
  mainSubHeader: "Laden Sie hilfreiche Factsheets und Anleitungen herunter.",

    altHelp: 'Hilfe',
    altInfo: 'Info',
    altAppStore: 'Im App Store laden',
    altGooglePlay: 'Bei Google Play herunterladen',
    ariaGoToSlide: 'Zur Folie {n} wechseln',
    ariaNextSlide: 'Nächste Folie',
    ariaPrevSlide: 'Vorherige Folie',
    videoNotSupportedText: 'Ihr Browser unterstützt das Video-Tag nicht.',
    virtualModeTooltipText: 'Der virtuelle Modus ermöglicht es Ihnen, die App zu testen, ohne mit einer echten Insulinpumpe und einem CGM-Sensor verbunden zu sein.',
    closeButtonText: 'Schließen',
    filterAll: 'Alle',
    filterYpsoPump: 'YpsoPump',
    filterDana: 'Dana',
    sortNewest: 'Neueste',
    sortOldest: 'Älteste',
    sortAZ: 'A-Z',
    sortPopular: 'Am beliebtesten',
  // Getting Started Section
  gettingStartedHeader: "Bereit anzufangen?",
  step1Title: "<strong>Schritt 1:</strong> App herunterladen",
  step2Title: "<strong>Schritt 2:</strong> Erstellen Sie ein Konto",
  step3Title: "<strong>Schritt 3:</strong> Beginnen Sie mit der In-App-Schulung",
  step4Title: "<strong>Schritt 4:</strong> Koppeln Sie Ihre gew&auml;hlte Pumpe und CGM (mit Genehmigung Ihres Behandlungsteams) oder erkunden Sie die App im <strong>Virtual Mode</strong>",

  // Support Section
  supportSectionTitle: "Brauchen Sie mehr Hilfe?",
  supportSectionText:
    "Unser Support-Team steht Ihnen bei allen Fragen zur Verfügung.",
  supportButtonText: "SUPPORT KONTAKTIEREN",

  factsheets: [
    // {
    //     id: 1,
    //     title: 'Linking CamAPS FX to Glooko',
    //     description: 'Linking CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-001.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-001-linking-glooko.pdf'
    // },
    // {
    //     id: 2,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-002.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-002-pdf-report.pdf'
    // },
    // {
    //     id: 3,
    //     title: 'Managing Hypos on CamAPS FX',
    //     description: 'Managing Hypos on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-003.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-003-managing-hypos.pdf'
    // },
    // {
    //     id: 4,
    //     title: 'Managing Illness on CamAPS FX',
    //     description: 'Managing Illness on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-004.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-004-managing-illness.pdf'
    // },
    // {
    //     id: 5,
    //     title: 'Managing Meals on CamAPS FX',
    //     description: 'Managing Meals on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-005.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-005-managing-meals.pdf'
    // },
    // {
    //     id: 6,
    //     title: 'Travelling with CamAPS FX',
    //     description: 'Travelling with CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-006.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-006-travelling.pdf'
    // },
    // {
    //     id: 7,
    //     title: 'Getting support on CamAPS FX',
    //     description: 'Getting support on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-007.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-007-getting-support.pdf'
    // },
    // {
    //     id: 8,
    //     title: 'Using CamAPS FX at school, nursery or in childcare',
    //     description: 'Using CamAPS FX at school, nursery or in childcare',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-008.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-008-at-school.pdf'
    // },
    // {
    //     id: 9,
    //     title: 'CamAPS FX School\'s Care Plan Template',
    //     description: 'CamAPS FX School\'s Care Plan Template',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-009.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-009-care-plan-template.docx'
    // },
    // {
    //     id: 10,
    //     title: 'Using CamAPS FX in virtual (demo) mode',
    //     description: 'Using CamAPS FX in virtual (demo) mode',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-010.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-010-demo-mode.pdf'
    // },
    // {
    //     id: 11,
    //     title: 'CamAPS FX and its Patency Pulse',
    //     description: 'CamAPS FX and its Patency Pulse',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-011.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-011-patency-pulse.pdf'
    // },
    // {
    //     id: 12,
    //     title: 'Having Surgery or a Procedure when using CamAPS FX',
    //     description: 'Having Surgery or a Procedure when using CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-012.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-012-surgery-procedure.pdf'
    // },
    // {
    //     id: 13,
    //     title: 'Managing Pregnancy on CamAPS FX',
    //     description: 'Managing Pregnancy on CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-013.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-013-managing-pregnancy.pdf'
    // },
    // {
    //     id: 14,
    //     title: 'Optimising CamAPS FX',
    //     description: 'Optimising CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-014.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-014-optimising.pdf'
    // },
    // {
    //     id: 15,
    //     title: 'Starting CamAPS FX - training slide deck',
    //     description: 'Starting CamAPS FX - training slide deck',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-015.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-015-training-slides.pdf'
    // },
    // {
    //     id: 16,
    //     title: 'Preparing to start CamAPS FX',
    //     description: 'Preparing to start CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'dana',
    //     image: '/images/factsheets/factsheet-016.jpg',
    //     pdfUrl: '/pdfs/factsheets/dana-016-preparing-to-start.pdf'
    // },
    // {
    //     id: 17,
    //     title: 'Introduction to mylife CamAPS FX',
    //     description: 'Introduction to mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-017.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-017-introduction-ch-de.pdf'
    // },
    // {
    //     id: 18,
    //     title: 'mylife CamAPS FX Specifications',
    //     description: 'mylife CamAPS FX Specifications',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-018.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-018-specifications-ch-de.pdf'
    // },
    // {
    //     id: 19,
    //     title: 'mylife CamAPS FX Infographic',
    //     description: 'mylife CamAPS FX Infographic',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-019.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-019-infographic-ch-de.pdf'
    // },
    // {
    //     id: 20,
    //     title: 'Choice of Sensors',
    //     description: 'Choice of Sensors',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-020.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-020-sensors-ch-de.pdf'
    // },
    // {
    //     id: 21,
    //     title: 'Starting mylife CamAPS FX',
    //     description: 'Starting mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-021.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-021-starting-ch-de.pdf'
    // },
    // {
    //     id: 22,
    //     title: 'Patency pulse on mylife CamAPS FX',
    //     description: 'Patency pulse on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-022.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-022-patency-pulse-ch-de.pdf'
    // },
    // {
    //     id: 23,
    //     title: 'Travelling with mylife CamAPS FX',
    //     description: 'Travelling with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-023.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-023-travelling-ch-de.pdf'
    // },
    // {
    //     id: 24,
    //     title: 'Managing illness on mylife CamAPS FX',
    //     description: 'Managing illness on mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-024.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-024-illness-ch-de.pdf'
    // },
    // {
    //     id: 25,
    //     title: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     description: 'Managing mylife CamAPS FX during surgery, CT or MRI scans',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-025.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-025-surgery-ch-de.pdf'
    // },
    // {
    //     id: 26,
    //     title: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     description: 'Managing low glucose levels (hypos) with mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-026.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-026-hypos-ch-de.pdf'
    // },
    // {
    //     id: 27,
    //     title: 'Optimising mylife CamAPS FX',
    //     description: 'Optimising mylife CamAPS FX',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-027.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-027-optimising-ch-de.pdf'
    // },
    // {
    //     id: 28,
    //     title: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     description: 'Using mylife CamAPS FX at school, nursery or when childminding',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-028.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-028-school-ch-de.pdf'
    // },
    // {
    //     id: 29,
    //     title: 'Generating a PDF report',
    //     description: 'Generating a PDF report',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-029.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-029-pdf-report.pdf'
    // },
    // {
    //     id: 30,
    //     title: 'Linking mylife CamAPS FX to Glooko',
    //     description: 'Linking mylife CamAPS FX to Glooko',
    //     date: '20 Jun 2024',
    //     category: 'ypso',
    //     image: '/images/factsheets/factsheet-030.jpg',
    //     pdfUrl: '/pdfs/factsheets/ypso-030-linking-glooko.pdf'
    // }
    {
      id: 1,
      title: "Anpassen der voreingestellten Mahlzeitengrößen",
      description: "Anpassen der voreingestellten Mahlzeitengrößen",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/adjusting_meal_sizes.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/adjusting_meal_sizes_camdiab_DE.pdf",
      views: 4000,
    },
    {
      id: 2,
      title: "Kalibrieren eines Sensors",
      description: "Kalibrieren eines Sensors",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/calibrating_a_sensor.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/calibrating_a_sensor_camdiab_DE.pdf",
      views: 3000,
    },
    {
      id: 3,
      title: "Ändern der Kohlenhydrateinheiten",
      description: "Ändern der Kohlenhydrateinheiten",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/changing_carbohydrate_units.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/changing_carbohydrate_units_camdiab_DE.pdf",
      views: 2000,
    },
    {
      id: 4,
      title: "Eingeben des Körpergewichts",
      description: "Eingeben des Körpergewichts",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_body_weight.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/entering_body_weight_camdiab_DE.pdf",
      views: 31000,
    },
    {
      id: 5,
      title: "Eingeben der Insulin-Tagesgesamtdosis (TDD)",
      description: "Eingeben der Insulin-Tagesgesamtdosis (TDD)",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/entering_total_daily_dose.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/entering_total_daily_dose_camdiab_DE.pdf",
      views: 30000,
    },
    {
      id: 6,
      title: "Abgeben eines manuellen Korrekturbolus",
      description: "Abgeben eines manuellen Korrekturbolus",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_correction.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/giving_a_correction_camdiab_DE.pdf",
      views: 22000,
    },
    {
      id: 7,
      title: "Abgeben eines Mahlzeitenbolus",
      description: "Abgeben eines Mahlzeitenbolus",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/giving_a_meal_bolus.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/giving_a_meal_bolus_camdiab_DE.pdf",
      views: 26000,
    },
    {
      id: 8,
      title: "Wie gibt CamAPS FX Insulin ab?",
      description: "Wie gibt CamAPS FX Insulin ab?",
      date: "20 Jun 2024",
      category: "ypso",
      image:
        "/images/factsheets/thumbnail/how_does_camaps_fx_deliver_insulin.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/how_does_camaps_fx_deliver_insulin_camdiab_DE.pdf",
      views: 35000,
    },
    {
      id: 9,
      title: "Wie lernt CamAPS FX?",
      description: "Wie lernt CamAPS FX?",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/how_does_camaps_fx_learn.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/how_does_camaps_fx_learn_camdiab_DE.pdf",
      views: 36000,
    },
    {
      id: 10,
      title: "Schwangerschaftsmanagement",
      description: "Schwangerschaftsmanagement",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/managing_pregnancy.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/managing_pregnancy_camdiab_DE.pdf",
      views: 34000,
    },
    {
      id: 11,
      title: "Koppeln von Pumpe und Sensor",
      description: "Koppeln von Pumpe und Sensor",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/pairing_pump_and_sensor.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/pairing_pump_and_sensor_camdiab_DE.pdf",
      views: 32000,
    },
    {
      id: 12,
      title: "Durchlässigkeitsimpuls",
      description: "Durchlässigkeitsimpuls",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/patency_pulse.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/patency_pulse_camdiab_DE.pdf",
      views: 1000,
    },
    {
      id: 13,
      title: "Einrichten des Boluskalkulators",
      description: "Einrichten des Boluskalkulators",
      date: "20 Jun 2024",
      category: "ypso",
      image:
        "/images/factsheets/thumbnail/programming_bolus_calculator.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/programming_bolus_calculator_camdiab_DE.pdf",
      views: 29000,
    },
    {
      id: 14,
      title: "Alarme",
      description: "Alarme",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/setting_alerts.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/setting_alerts_camdiab_DE.pdf",
      views: 21000,
    },
    {
      id: 15,
      title: "Persönlicher Glukosezielwert",
      description: "Persönlicher Glukosezielwert",
      date: "20 Jun 2024",
      category: "ypso",
      image:
        "/images/factsheets/thumbnail/setting_personal_glucose_target.webp",
      pdfUrl:
        "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/setting_personal_glucose_target_camdiab_DE.pdf",
      views: 28000,
    },
    {
      id: 16,
      title: "Teilen von Diabetesdaten",
      description: "Teilen von Diabetesdaten",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/sharing_diabetes_data.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/sharing_diabetes_data_camdiab_DE.pdf",
      views: 20000,
    },
    {
      id: 17,
      title: "Technische Tipps",
      description: "Technische Tipps",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/top_technical_tips.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/top_technical_tips_camdiab_DE.pdf",
      views: 33000,
    },
    {
      id: 18,
      title: "Verwenden von „Mahlzeit eingeben”",
      description: "Verwenden von „Mahlzeit eingeben”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_add_meal.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/using_add_meal_camdiab_DE.pdf",
      views: 25000,
    },
    {
      id: 19,
      title: "Verwenden des „Auto mode”",
      description: "Verwenden des „Auto mode”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_auto_mode.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/using_auto_mode_camdiab_DE.pdf",
      views: 27000,
    },
    {
      id: 20,
      title: "Verwenden der „Kindersicherung”",
      description: "Verwenden der „Kindersicherung”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_block.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/using_block_camdiab_DE.pdf",
      views: 19000,
    },
    {
      id: 21,
      title: "Verwenden von „Boost”",
      description: "Verwenden von „Boost”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_boost.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/using_boost_camdiab_DE.pdf",
      views: 23000,
    },
    {
      id: 22,
      title: "Verwenden von „Ease-off”",
      description: "Verwenden von „Ease-off”",
      date: "20 Jun 2024",
      category: "ypso",
      image: "/images/factsheets/thumbnail/using_ease_off.webp",
      pdfUrl: "https://s3.eu-west-1.amazonaws.com/camdiab.training.material/02+Factsheets/de_DE/using_ease_off_camdiab_DE.pdf",
      views: 24000,
    },
  ],
};
